class @App.Clubs.ClubsResourcesOrientation
  $document = $(document)
  $video = $('#orientation-video')
  video = $video.get(0)
  $orientation = $('#orientation')
  $hidden = $('[data-orientation="hide"]')
  skipSelector = '[data-action="skip-orientation"]'
  $skipBtn = $(skipSelector)
  startSelector = '[data-action="start-orientation"]'
  $startBtn = $(startSelector)
  completeSelector = '[data-action="complete-orientation"]'
  $completeBtn = $(completeSelector)
  $viewedItem = $('[data-component="todosCheck"][data-slug="video"]')
  firstSection = '#welcome-section'

  # See https://github.com/daneden/animate.css/issues/644
  animationEnd = ((el) ->
    animations =
      'animation': 'animationend'
      'OAnimation': 'oAnimationEnd'
      'MozAnimation': 'mozAnimationEnd'
      'WebkitAnimation': 'webkitAnimationEnd'
    for t of animations
      if el.style[t] != undefined
        return animations[t]
    return
  )(document.createElement('div'))

  constructor: ->
    @injectClasses()
    @bindElements()
    @setupOrientation()

  injectClasses: ->
    $('head').append('<style>.tdd-orientation--hidden {
        position:absolute;
        opacity:0;
        pointer-events:none;
      }</style>');
    return

  bindElements: =>
    $document.on 'click.clubsIntro', skipSelector, @endOrientation
    $document.on 'click.clubsIntro', startSelector, () -> video.play()
    $document.on 'click.clubsIntro', completeSelector, @endOrientation
    $video.on 'play', @videoPlay
    $video.on 'timeupdate', @videoTimeupdate
    $video.on 'ended pause', @videoStop
    $video.on 'ended', @updateOrientationViewed
    return

  setupOrientation: ->
    history.pushState('', '', '#orientation') if location.hash != '#orientation'
    @showOrientation()

  resetStartBtn: =>
    $startBtn
      .text 'Watch Now'
      .removeClass 'tdd-btn--dark'
      .css 'pointer-events', 'auto'

  endOrientation: =>
    history.pushState('', '', firstSection)
    @hideOrientation()

  showOrientation: =>
    @resetStartBtn()
    video.currentTime = 0
    video.load()
    $orientation
      .show()
      .css 'height', 'auto'
      .removeClass 'hidden'
      .addClass 'tdd-fx tdd-fx--fade-in'
    $hidden
      .removeClass 'tdd-fx--fade-in'
      .addClass 'tdd-orientation--hidden'
    $video.siblings().removeClass 'tdd-orientation--hidden'
    $video
      .addClass 'tdd-fx'
      .css 'animation-name', ''
    $completeBtn.hide()

  hideOrientation: =>
    video.pause()
    video.currentTime = 0
    $orientation.one animationEnd, () ->
      $orientation.hide()
    $orientation.css 'height', '0'
    $video.siblings().addClass 'tdd-orientation--hidden'
    $hidden
      .removeClass 'tdd-orientation--hidden'
      .addClass('tdd-fx tdd-fx--fade-in')
    $video.css 'animation-name', 'orientationClose'
    return

  videoPlay: =>
    $skipBtn.show()
    $startBtn
      .text 'Loading...'
      .addClass 'tdd-btn--dark'
      .css 'pointer-events', 'none'
    return

  videoStop: =>
    if video.currentTime >= video.duration
      $skipBtn.hide()
      $startBtn.hide()
      $completeBtn.show()
    else
      @resetStartBtn()
      $startBtn.show()
      $skipBtn.show()
      $completeBtn.hide()
    return

  endOrientation: =>
    history.pushState('', '', firstSection)
    @hideOrientation()
    return

  updateOrientationViewed: =>
    $viewedItem.prop 'checked', true
    $viewedItem.trigger 'change'
    return

  videoTimeupdate: =>
    if video.paused
      @videoStop()
      return

    t = video.duration - video.currentTime
    m = Math.floor t / 60
    s = Math.floor ((t % 60) * 100) / 100
    $startBtn.text("Done in... " + if m > 0 then m + "m" else s + "s" )

$ ->
  id = '#orientation'
  orientation = false

  # if no orientation is present on the page we don't need to bind anything.
  if $(id).length < 1
    return

  # Initiate the orientation if it hasn't been completed or the hash is present
  incomplete = $('[data-component="todosCheck"][data-slug="video"]:not(:checked)').length
  if (incomplete > 0 or location.hash == id) and location.hash != '#share-clubs'
    orientation = new App.Clubs.ClubsResourcesOrientation()

  # Initiate the orientation if the hash is added
  $(window).on 'hashchange', () ->
    if location.hash != id
      return

    if orientation == false
      orientation = new App.Clubs.ClubsResourcesOrientation()
    else
      orientation.setupOrientation()